import { ArrowRight, ChevronRight, Clock } from "lucide-react";

const TONE = {
  green: "border-emerald-300 bg-emerald-50", amber: "border-[#e2b85a] bg-[#fff7e3]", red: "border-red-300 bg-red-50",
};
const PILL = { green: "bg-emerald-600 text-white", amber: "bg-amber-400 text-[#3b1d00]", red: "bg-red-600 text-white" };
const TONE_LABEL = { green: "On track", amber: "Pending", red: "Overdue / action needed" };

export function StageFlow({ title, steps, accent }) {
  if (!steps?.length) return null;
  return (
    <div className="bi-panel" data-testid="bi-stage-flow">
      <h2 className="bi-panel-title" style={{ color: accent }}>{title} process</h2>
      <div className="flex flex-wrap items-stretch gap-2">
        {steps.map((s, i) => (
          <div key={s.label} className="flex items-center gap-2">
            <div className={`min-w-[132px] rounded-2xl border-2 px-4 py-3 ${s.count ? "border-[#e2b85a] bg-[#fff3d6]" : "border-emerald-200 bg-emerald-50"}`} data-testid={`bi-stage-${i}`}>
              <div className="flex items-center gap-2 text-sm font-semibold text-[#5a3a22]">
                <span className="grid h-6 w-6 place-items-center rounded-full text-xs text-white" style={{ background: accent }}>{i + 1}</span>{s.label}
              </div>
              <div className="mt-1 text-2xl font-bold text-[#3b0d0d]">{s.count}</div>
              <div className="text-xs">{s.count ? "waiting here" : "nothing pending"}</div>
            </div>
            {i < steps.length - 1 && <ArrowRight className="hidden sm:block h-5 w-5 text-[#a8781f]" />}
          </div>))}
      </div>
    </div>
  );
}

export function ActionCards({ cards, onShowRecords }) {
  return (
    <div className="bi-panel" data-testid="bi-action-cards">
      <div className="mb-3 flex items-center justify-between gap-2">
        <h2 className="bi-panel-title !mb-0">Current enquiries — action needed</h2>
        <button type="button" onClick={onShowRecords} className="flex items-center gap-1 text-base font-semibold text-[#7a0f1d]" data-testid="bi-view-all-records">All records<ChevronRight className="h-4 w-4" /></button>
      </div>
      {!cards?.length ? <p className="text-base text-emerald-700">Nothing waiting — all caught up.</p> : (
        <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
          {cards.map((c) => (
            <div key={c.ref} className={`rounded-2xl border-2 p-4 ${TONE[c.tone] || TONE.amber}`} data-testid={`bi-action-card-${c.ref}`}>
              <div className="truncate font-mono text-xs text-muted-foreground">{c.ref}</div>
              {c.amount != null && <div className="font-serif text-2xl font-bold text-[#3b0d0d]">{c.sym}{Number(c.amount || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}</div>}
              <div className="text-base font-semibold">{c.title}</div>
              {c.sub && <div className="text-sm text-muted-foreground">{c.sub}</div>}
              {c.when && <div className="mt-1 flex items-center gap-1 text-sm"><Clock className="h-4 w-4" />{c.when}</div>}
              <div className="mt-3 flex flex-wrap items-center gap-2">
                <span className={`rounded-full px-3 py-1 text-sm font-semibold ${PILL[c.tone] || PILL.amber}`} title={TONE_LABEL[c.tone]}>{c.stage}</span>
              </div>
              <div className="mt-2 text-sm font-semibold text-[#7a0f1d]">Next: {c.next}</div>
            </div>))}
        </div>)}
    </div>
  );
}
